export const EditEventContent = {
  // Page title
  pageTitle: 'Edit Event',

  // Header actions
  deleteEvent: 'Delete Event',

  // Section headings
  eventDetails: 'Event Details',
  rsvpAttendance: 'RSVP & Attendance',
  reviewSave: 'Review & Save',

  // Form fields
  title: 'Title',
  description: 'Description',
  location: 'Location',
  eventLink: 'Event Link',
  eventLinkPlaceholder: 'https://example.com/meeting',
  linkName: 'Link Name',
  linkNamePlaceholder: 'e.g., Join Online, View Document',
  date: 'Date',
  time: 'Time',
  startTime: 'Start time',
  endTime: 'End time',
  eventType: 'Event Type',
  eventTypeNote:
    'This is for internal purposes only and will not be displayed to users.',
  rsvpDeadline: 'RSVP Deadline',
  attendanceMax: 'Attendance Max',
  invitationGroupsLabel: 'Invitation Groups',

  // Invitation group options
  invitationGroupsOptions: {
    fellows: 'Fellows',
    circleAlumni: 'Circle Alumni',
    fellowAlumni: 'Fellow Alumni',
    circleMembers: 'Circle Members',
    admins: 'Admins',
    all: 'All',
  },

  // Buttons
  publish: 'Publish',
  cancel: 'Cancel',

  // Publish/Update drawer
  publishDrawer: {
    title: 'Publish Event?',
    message:
      'This event will become immediately visible to the following groups:',
    sendNotification: 'Send notification when event is added?',
    notificationMessagePlaceholder: 'Message included in notification',
    cancelButton: 'Cancel',
    publishButton: 'Publish',
  },
  updateDrawer: {
    title: 'Update Event?',
    message:
      'This event will become immediately visible to the following groups:',
    sendNotification: 'Send notification when event is updated?',
    notificationMessagePlaceholder: 'Message included in notification',
    cancelButton: 'Cancel',
    updateButton: 'Update',
  },
  deleteDrawer: {
    title: 'Delete Event?',
    message:
      'This event will become immediately marked as deleted and all scheduled notifications will be turned off.',
    deleteButton: 'Delete',
    cancelButton: 'Cancel',
  },
} as const;
